import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PractitionerComponent } from './practitioner/practitioner.component';
import { PractitionerCreateComponent } from './practitioner/practitioner-create/practitioner-create.component';
import { PractitionerListComponent } from './practitioner/practitioner-list/practitioner-list.component';
import { PractitionerTestimonialComponent } from './practitioner/practitioner-testimonial/practitioner-testimonial.component';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';
import { PractitionerDetailComponent } from './practitioner/practitioner-detail/practitioner-detail.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { RegisterGuard } from './shared/guards/register.guard';
import { PractitionerRegisterComponent } from './practitioner/practitioner-register/practitioner-register.component';
import { AdminComponent } from './admin/admin.component';
import { AdminLoginComponent } from './admin/admin-login/admin-login.component';
import { AdminPractitionerListComponent } from './admin/admin-practitioner-list/admin-practitioner-list.component';
import { AdminGuard } from './shared/guards/admin.guard';
import { PractitionerBookingsComponent } from './practitioner/practitioner-bookings/practitioner-bookings.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent},
  { path: 'search', component: SearchComponent },
  { path: 'practitioner', component: PractitionerComponent, children: [
    { path: '', component: PractitionerListComponent, pathMatch: 'full' },
    { path: 'create', component: PractitionerCreateComponent },
    { path: ':id', component: PractitionerDetailComponent },
    { path: ':id/edit', component: PractitionerCreateComponent, canActivate: [AuthGuard] },
    { path: ':id/bookings', component: PractitionerBookingsComponent, canActivate: [AuthGuard] },
    { path: ':id/testimonial', component: PractitionerTestimonialComponent },
    { path: ':id/register', component: PractitionerRegisterComponent, canActivate: [RegisterGuard] }
  ]},
  { path: 'admin', component: AdminComponent, canActivate: [AdminGuard], children: [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: AdminLoginComponent },
    { path: 'practitioners', component: AdminPractitionerListComponent }
  ]},
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
